import { useNavigate, useParams } from 'react-router-dom';
import './List.scss';
import { useEffect, useState } from 'react';
import api from '../../js/api';
import Task from '../../components/Task/Task';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import { toast } from 'react-toastify';

export default function List() {

    const { listID } = useParams();

    const [tasks, setTasks] = useState([]);
    const [sharedWith, setSharedWith] = useState([]);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [userSelectModal, setUserSelectModal] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        console.log('List isOpenModal changed:', isOpenModal);
    }, [isOpenModal]);

    function taskOrder(a, b) {
        if (a.is_completed && !b.is_completed) return 1;
        if (!a.is_completed && b.is_completed) return -1;
        return 0;
    }

    useEffect(() => {
        if (!listID) {
            return navigate('/lists', { replace: true });
        }

        console.log('List ID:', listID);

        api.get(`/user/lists/${listID}/tasks`).then((data) => {
            data.sort(taskOrder);
            setTasks(data);
        });
    }, [])

    return (
        <div id="list">
            <div className="centered-container">
                <h1>List Page</h1>
                <br />
                <div className='flex gap'>
                    <Button onClick={() => setIsOpenModal(true)} >
                        <span className='material-icon'>add</span> Add New Task
                    </Button>
                    <Button onClick={() => {
                        api.get(`/user/lists/${listID}`).then((data) => {
                            console.log(data)
                            setSharedWith(data.users || []);
                        });
                        setUserSelectModal(true);
                    }}>
                        <span className='material-icon'>groups</span> Users
                    </Button>
                </div>
                {isOpenModal &&
                    <Modal
                        text="Add New Task"
                        isOpen={true}
                        callback={() => setIsOpenModal(false)}
                    >
                        <div className='flex flex-column gap'>
                            <h2>New Task</h2>
                            <br />
                            <input id="title" type="text" placeholder="Task Title (Optional)" className='input' />
                            <textarea id='description' placeholder="Task Description" className='input' />
                            <div className='flex gap flex-space-between'>
                                <Button text="Cancel" class_="red white-text" onClick={() => {
                                    setIsOpenModal(false);
                                }} />
                                <Button text="Add Task" onClick={() => {
                                    const title = document.getElementById('title').value;
                                    const description = document.getElementById('description').value;

                                    if (!description) {
                                        alert('Please provide a description for the task.');
                                        return;
                                    }
                                    if (!window.confirm('Are you sure you want to add this task?')) {
                                        return;
                                    }

                                    api.post(`/user/lists/${listID}/tasks`, {
                                        title: title || null,
                                        description: description
                                    }).then(async (data) => {
                                        if (data.error) {
                                            console.error('Error adding task:', data.error);
                                            return;
                                        }
                                        const tasks = await api.get(`/user/lists/${listID}/tasks`);
                                        console.log('Updated tasks:', tasks);
                                        tasks.sort(taskOrder);
                                        setTasks(tasks);
                                        setIsOpenModal(false);
                                    }).catch((err) => {
                                        console.error('Error adding task:', err);
                                    });

                                }} />
                            </div>
                        </div>
                    </Modal>
                }
                {userSelectModal &&
                    <Modal
                        text="Select User to Share With"
                        isOpen={true}
                        callback={() => setUserSelectModal(false)}
                    >
                        <h3>Users with Access</h3>
                        <div className='flex flex-column gap margin-top'>
                            {sharedWith.length > 0 ? (
                                sharedWith.map((user) => (
                                    <div key={user} className='flex gap flex-center'>
                                        <p key={user} className='flex-1'>
                                            {user.charAt(0).toUpperCase() + user.slice(1)}
                                        </p>
                                        <Button
                                            class_="red white-text"
                                            onClick={async () => {
                                                if (!window.confirm(`Are you sure you want to remove ${user}'s access to this list?`)) {
                                                    return;
                                                }
                                                const resp = await api.delete(`/lists/${listID}/users/${user}`, { silent: true });
                                                if (resp.error) {
                                                    toast.error(resp.error);
                                                    return;
                                                }

                                                setSharedWith(sharedWith.filter(u => u !== user));
                                            }}>
                                            <span className='material-icon'>remove_circle</span>
                                        </Button>
                                    </div>
                                ))
                            ) : (
                                <p>No users have access to this list.</p>
                            )}
                        </div>
                        {/* <UserSelect onSelect={(user) => {
                            console.log('Selected user:', user);
                            setUserSelectModal(false);
                        }} /> */}
                    </Modal>
                }
                <div>
                    {
                        tasks.length > 0 ? (
                            tasks.map((task, index) => (
                                <Task taskData={task} listID={listID} key={task.id} />
                            ))
                        ) : (
                            <p className='margin'>No tasks available in this list.</p>
                        )
                    }
                </div>
                <Button text="Back to Lists" onClick={() => navigate('/lists')} />
            </div>
        </div >
    );
}